export function convertModulesToValues(modules: number[]) {
    return modules.map(module => `${module}`);
}

export function isModuleActive(modules: string[], value: number) {
    return modules.includes(`${value}`);
}
